var solumaxAuthClientPlugins = angular
	.module('Solumax.AuthClientPlugin', [])